import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { pageChanged } from '../../../../data/redux/page_details/actions';
import * as dashboardActions from '../../../../data/redux/dashboard_details/actions';

import { APP_PAGES, SOCKET_EVENTS } from '../../../../data/config/constants';
import { showMessage } from '../../../../data/config/utils';
import { BRAND_INFO } from '../../../../data/config/urls';
import { IMG_GRAPH } from '../../../../data/assets/img';

import CustomHeader from '../../../../components/customheader';
import ChartStatusCard from '../../components/chartstatuscard';
import Graph from '../../components/charts/graph';
import SpinnerLoader from '../../../../components/spinnerloader';
import ShowMessage from '../../../../components/showmessage';

const scale_per_sec = {
  count: {
    min: 0
  },
  timestamp: {
    type: 'time',
    tickInterval: 15 * 1000,
    mask: 'HH:mm:ss',
    range: [0, 1],
  }
};

const pastHoursLiveTrafficGranularity = [
  { value: 1, name: 'Last 1 hr' },
  { value: 2, name: 'Last 2 hr' },
  { value: 4, name: 'Last 4 hr' },
  { value: 6, name: 'Last 6 hr' },
];

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      nHoursTimeSeriesLoading: false
    }
  }

  componentWillMount() {
    const { actions } = this.props;
    const current_module = BRAND_INFO.usage_home_page ? APP_PAGES.ANALYTICS : APP_PAGES.DASHBOARD;
    actions.pageChanged(APP_PAGES.DASHBOARD, current_module);
  }

  componentDidMount() {
    const { dashboard_details, actions } = this.props;
    const { socket } = this.props.dashboard_details.socket_details;
    if (!dashboard_details.socket_details.connectivity.is_socket_connected) {
      actions.registerDashboardSocketListener();
    } else if (socket && socket.emit) {
      socket.emit(SOCKET_EVENTS.JOIN_LIVE_STATS, {})
    }
  }

  componentDidUpdate(prevProps) {
    const { socket_details } = this.props.dashboard_details;
    const { socket } = this.props.dashboard_details.socket_details;
    if (!prevProps.dashboard_details.socket_details.connectivity.is_socket_connected && socket_details.connectivity.is_socket_connected && socket.emit) {
      socket.emit(SOCKET_EVENTS.JOIN_LIVE_STATS, {})
    }
  }

  componentWillUnmount() {
    const { socket } = this.props.dashboard_details.socket_details
    if (socket && socket.emit)
      socket.emit(SOCKET_EVENTS.LEAVE_LIVE_STATS, {})
  }

  handlePastHoursLiveTrafficPerMin = event => {
    const { actions, dashboard_details } = this.props;
    const { socket } = this.props.dashboard_details.socket_details;
    const nHours = event.target.value;
    const prevnHours = dashboard_details.filters.nHours;
    actions.updateDashboardState(nHours, 'filters.nHours');
    this.setState({ nHoursTimeSeriesLoading: true });
    socket.emit(SOCKET_EVENTS.LAST_N_HOURS_TIME_SERIES, { nHours }, (res) => {
      this.setState({ nHoursTimeSeriesLoading: false });
      if (res && !res.err) {
        actions.updateScalePerMin(nHours);
      } else {
        actions.updateDashboardState(prevnHours, 'filters.nHours');
        showMessage('error', 'Some Error occured');
      }
    });
  };

  renderLiveCountCard = () => {
    const { dashboard_details } = this.props;
    if (dashboard_details.live_count.length > 0) {
      return (
        <div className="ori-flex ori-flex-wrap ori-lr-mrgn-neg-10 ori-t-pad-5 ori-b-pad-10">
          {
            dashboard_details.live_count.map((item, index) => {
              return (
                <div key={index} className="ori-stats-card-width ori-pad-10">
                  <ChartStatusCard card_data={item} value_key="count" />
                </div>
              );
            })
          }
        </div>
      );
    }
  };

  renderLiveTrafficPerSec = () => {
    const { dashboard_details } = this.props;
    if (dashboard_details.live_traffic_per_sec.length > 0) {
      return (
        <Graph type="line" data={dashboard_details.live_traffic_per_sec} scale={scale_per_sec} x_axis="timestamp" y_axis="count" color_key="userType" padding={[60, 25, 50, 60]} height={350} legend />
      );
    } else {
      return (
        <div style={{ height: '350px' }}>
          <ShowMessage img_src={IMG_GRAPH} height={120} width={140} title='record not found' />
        </div>
      );
    }
  };

  renderLiveTrafficPerMinute = () => {
    const { dashboard_details } = this.props;
    if (dashboard_details.live_traffic_per_min.length > 0) {
      return (
        <Graph type="area" data={dashboard_details.live_traffic_per_min} scale={dashboard_details.live_traffic_scale_per_min} x_axis="timestamp" y_axis="count" color_key="userType" padding={[60, 25, 50, 60]} height={350} legend />
      );
    } else {
      return (
        <div style={{ height: '350px' }}>
          <ShowMessage img_src={IMG_GRAPH} height={120} width={140} title='record not found' />
        </div>
      );
    }
  };

  render() {
    const { dashboard_details } = this.props;
    const { nHoursTimeSeriesLoading } = this.state;
    return (
      <div className="ori-lr-pad-10">
        <CustomHeader title="live statistics" bottom_bordered />
        <div className="ori-tb-pad-5">
          {this.renderLiveCountCard()}
          <div className="ori-animated ori-zoom-in ori-bg-white ori-lr-pad-15 ori-b-mrgn-10 ori-border-radius-4 ori-box-shadow-light">
            <CustomHeader title="Live Traffic per Sec" />
            {this.renderLiveTrafficPerSec()}
          </div>
          <div className="ori-animated ori-zoom-in ori-bg-white ori-lr-pad-15 ori-b-mrgn-10 ori-border-radius-4 ori-box-shadow-light">
            <CustomHeader left_wrapper_class="ori-flex-row ori-flex-wrap ori-full-flex ori-flex-jsb" granularity_disabled={dashboard_details.live_traffic_per_min.length === 0} title="Live Traffic per Min" show_granularity granularity_options={pastHoursLiveTrafficGranularity} granularity_value={dashboard_details.filters.nHours} onChangeGranularity={this.handlePastHoursLiveTrafficPerMin} />
            {
              nHoursTimeSeriesLoading &&
              <div className="ori-absolute ori-align-full ori-bg-white ori-zindex-1 ori-opacity-medium ori-flex-row ori-flex-jc ori-flex-ac">
                <SpinnerLoader size="large" text="loading" />
              </div>
            }
            {this.renderLiveTrafficPerMinute()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dashboard_details: state.dashboard_details
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged }, dashboardActions), dispatch)
  };
}

Dashboard.propTypes = {
  actions: PropTypes.object,
  dashboard_details: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Dashboard);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/dashboard/index.js